/**
 * Maps an array of data items to a template.
 * @param {Array} results
 * @param {jQuery} $familyTemplate
 * @return {Element[]}
 */
const mapProductDataToTemplate = (results, $familyTemplate) => {
    // transform product results
    const productsByFamily = results.reduce(
        (acc, product) => ({
            ...acc,
            [product.family]: Array.isArray(acc[product.family])
                ? acc[product.family].concat(product)
                : [product],
        }),
        {}
    );

    // map to template
    return Object.entries(productsByFamily).map(([family, products]) => {
        const $family = $familyTemplate.clone();
        const $productTemplate = $family
            .find('[data-child-template]')
            .removeAttr('data-child-template')
            .detach();

        const $products = products.map((entry) => {
            const $item = $productTemplate.clone();
            $item.find('[data-name]').text(entry.name);
            $item
                .find('[data-img]')
                .attr(
                    'src',
                    entry.img.replace('/home/10013_ansorg.com//w', '')
                );
            $item.find('[data-url]').attr('href', entry.url);

            return $item;
        });

        $family.find('[data-family]').text(family);
        $family.find('[data-products]').empty().append($products);

        return $family.get(0);
    });
};

export default mapProductDataToTemplate;



// WEBPACK FOOTER //
// ./src/scripts/components/search/mapProductDataToTemplate.js